import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-zinc-950 font-sans text-stone-100" data-id="element-0" data-mp="31cjk5p91r2w3">
      <Hero data-id="element-1" data-mp="2wifhhi6tdh0t" />
      <main data-id="element-2" data-mp="2whx8rm2ytac0">
        <ProblemSection data-id="element-3" data-mp="2wi5m1f302hnq" />
        <VolumesSection data-id="element-4" data-mp="28tw4wqgqei2x" />
        <BonusesSection data-id="element-5" data-mp="28t4mkhc5agul" />
        <OfferSection data-id="element-6" data-mp="28skzynbjv4a8" />
        <GuaranteeSection data-id="element-7" data-mp="23vck4tdvjcc5" />
        <FaqSection data-id="element-8" data-mp="23w4gi6fape3h" />
        <FinalCtaSection data-id="element-9" data-mp="23ujlygszdv5m" />
      </main>
      <Footer data-id="element-10" data-mp="23ti7018ugoim" />
      <StickyCta data-id="element-11" data-mp="3ik7g4ghnibqn" />
    </div>;
}